// Vergi hesabı — tek doğru kaynak.
// Backend karşılığı: HotelFlow.BusinessLayer/Hesaplama/VergiHesaplayici.cs
//
// KURAL: Konaklama vergisi KDV matrahına dahil edilmez. İkisi de aynı taban
// (KDV hariç konaklama bedeli) üzerinden ayrı ayrı hesaplanır.
//
//   400 + (400 × %10) + (400 × %2) = 448,00   doğru
//   400 × 1,10 × 1,02              = 448,80   yanlış

/**
 * Net fiyata vergileri ekler (B2B / anlaşmalı firma modeli).
 * kdvDahilMi işaretliyse fiyat KDV'yi zaten içerir, KDV tekrar eklenmez;
 * konaklama vergisi her durumda eklenir.
 */
export function brutTutar(fiyat, kdvOrani = 0, kdvDahilMi = false, konaklamaVergisi = 0) {
  const net = Number(fiyat) || 0;
  if (net <= 0) return 0;
  const matrah = kdvDahilMi && kdvOrani > 0 ? net / (1 + kdvOrani / 100) : net;
  const kdv = kdvDahilMi ? 0 : matrah * (kdvOrani / 100);
  const konVergi = matrah * (konaklamaVergisi / 100);
  return +(net + kdv + konVergi).toFixed(4);
}

/**
 * Vergi çarpanı — net fiyatı brüte çeviren katsayı.
 * Fiyat önerisi hesaplarında kullanılır.
 */
export function vergiCarpani(kdvOrani = 0, kdvDahilMi = false, konaklamaVergisi = 0) {
  return 1 + (kdvDahilMi ? 0 : (kdvOrani || 0) / 100) + (konaklamaVergisi || 0) / 100;
}

/**
 * Vergi dahil tutarı bileşenlerine ayırır (B2C / oda tipi fiyatlandırması).
 * @returns {{matrah:number, kdv:number, konaklamaVergisi:number}}
 */
export function vergiAyristir(brut, kdvOrani = 0, konaklamaVergisiOrani = 0) {
  const tutar = Number(brut) || 0;
  if (tutar <= 0) return { matrah: 0, kdv: 0, konaklamaVergisi: 0 };

  const bolen = 1 + (kdvOrani || 0) / 100 + (konaklamaVergisiOrani || 0) / 100;
  const matrah = bolen > 0 ? tutar / bolen : tutar;

  return {
    matrah: +matrah.toFixed(2),
    kdv: +(matrah * (kdvOrani || 0) / 100).toFixed(2),
    konaklamaVergisi: +(matrah * (konaklamaVergisiOrani || 0) / 100).toFixed(2),
  };
}
